import { API_USER_SERVICE } from "../config/Constants";
import { getRequest } from "./Rest";

// Global Search APIs

export const globalSearch = async (keyword: string) => {
    const path = `${API_USER_SERVICE}/orders/search?keyword=${keyword}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data;
    return Array.isArray(dataResponse) ? dataResponse : [];
};